/**
 * I passi del tutorial guidato della pagina "Analisi prezzi" Amazon.
 *
 * Niente da preparare prima dei passi: i bersagli che dipendono dai dati hanno
 * `timeout: 250`, cosi' a elenco vuoto la card si aggancia in basso senza attese.
 */
export function createPriceAnalysisTourSteps() {
	return [
		{
			body: `Qui trovi tutte le tue pubblicazioni attive su Amazon, anche quelle non collegate a un prodotto del catalogo. Lo scopo e' capire chi ha la buybox sui prodotti che ti interessano e, se serve, correggere il prezzo. Per ora e' tutto manuale: sei tu a decidere cosa analizzare e quando cambiare prezzo.`,
			key: 'intro',
			placement: 'bottom',
			target: '[data-tour="tutorial"]',
			title: 'Analisi prezzi',
		},
		{
			body: `Ogni paese ha il suo elenco, le sue stelline e le sue analisi. Nella tendina compaiono i paesi dove hai pubblicazioni, e si parte da quello che usi di piu'.`,
			key: 'country',
			placement: 'bottom',
			target: '[data-tour="country"]',
			title: 'Scegliere il paese',
		},
		{
			body: `E' lo stesso aggiornamento della pagina Associa prodotti: un solo download del report Amazon aggiorna entrambe le pagine. Qui restano le pubblicazioni attive: le nuove vengono aggiunte, prezzi e giacenze aggiornati, e le stelline e le analisi gia' fatte restano. E' un lavoro in coda che puo' durare qualche minuto: arriva una notifica quando e' pronto.`,
			key: 'scan',
			placement: 'bottom',
			target: '[data-tour="scan"]',
			title: 'Aggiorna elenco',
		},
		{
			body: `La stellina gialla indica un prodotto seguito: solo i prodotti seguiti vengono analizzati. Clicca di nuovo per smettere di seguirlo.`,
			key: 'follow',
			placement: 'right',
			target: '[data-tour="follow"]',
			timeout: 250,
			title: 'Seguire un prodotto',
		},
		{
			body: `Si lancia a mano e legge da Amazon chi ha la buybox e a che prezzo, solo per i prodotti seguiti con la stellina di questo paese. Le richieste partono a distanza di qualche secondo l'una dall'altra per rispettare i limiti di Amazon: con molti prodotti ci vuole un po', e arriva una notifica alla fine.`,
			key: 'analysis',
			placement: 'bottom',
			target: '[data-tour="analysis"]',
			title: 'Effettua analisi',
		},
		{
			body: `Filtra l'elenco: solo i prodotti seguiti, oppure per esito della buybox (nostra, persa, nessuna). "Buybox di altri" e' il punto di partenza per capire dove intervenire.`,
			key: 'filters',
			placement: 'bottom',
			target: '[data-tour="filters"]',
			title: 'Filtri',
		},
		{
			body: `Il cliente paga prezzo + spedizione, quindi il confronto giusto e' fra i totali: sotto il prezzo della buybox c'e' il suo totale, sotto il nostro prezzo la nostra spedizione (letta da Amazon con l'analisi) e il nostro totale, in rosso quando siamo piu' cari della buybox. Associato o Non associato dice se la pubblicazione e' collegata a un prodotto del tuo catalogo.`,
			key: 'table',
			placement: 'top',
			target: '[data-tour="table"]',
			timeout: 250,
			title: 'Come si legge una riga',
		},
		{
			body: `Propone il prezzo con cui il nostro totale (prezzo + nostra spedizione) sta un centesimo sotto il totale della buybox, e puoi modificarlo. Se con la nostra spedizione non esiste un prezzo positivo che la batta, te lo dice invece di proporre un numero. Alla conferma il prezzo va subito ad Amazon, come \"Modifica su cms/marketplace\": se Amazon lo rifiuta vedi il motivo e da noi non cambia nulla. Se lo accetta e la pubblicazione e' associata, viene salvato anche sul prodotto.`,
			key: 'adjust',
			placement: 'left',
			target: '[data-tour="adjust"]',
			timeout: 250,
			title: 'Aggiusta prezzo',
		},
		{
			body: `Con le schede sotto il titolo passi alle altre pagine della sezione Amazon: Inserzioni, Associa prodotti, Regole feed e Repricing.`,
			key: 'tabs',
			placement: 'bottom',
			target: '[data-tour="tabs"]',
			title: 'Le altre pagine',
		},
	];
}
